<template>
  <div class="home">
    <div class="title">
      Danghuan
    </div>
    <div class="fail">
      <img src="../../assets/image/upload/5.png" alt="" class="fail-logo">
      <span>网络错误，请刷新页面</span>
    </div>
    
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'inspectionPhotographSuccess',
  components: {
  },
  data () {
    return {}
  },
  computed: {
    ...mapState({
      isMaxScreen: state => {
        return state.isMaxScreen
      }
    })
  },
  methods: {
  }
}
</script>
<style scoped lang="less">
@media (max-width: 980px) {

  .home{
    background: #F6F6F6;
  }

  .title{
    height: 88px;
    background-color: #fff;
    line-height: 88px;
  }

  .fail{
    display: flex;
    flex-direction: column;
    align-items: center;
    .fail-logo{
      width: 320px;
      height: 320px;
      margin-top: 216px;
    }
    span{
      color: #666;
      text-align: center;
      font-family: "PingFang SC";
      font-size: 30px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }


}
@media (min-width: 981px) {
  .home {
   
  }
}
</style>
